import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {PIXI} from '@colonist/pixi'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameManager} from '../UIGameManager'
import {UIGameDiceView} from './UIGameDiceView'

export class UIGameBaseDiceView extends UIGameDiceView {
    readonly dice1: SpriteView
    readonly dice2: SpriteView
    private readonly isRedDiceActive: boolean

    constructor(uiGameManager: UIGameManager, isRedDiceActive: boolean, x: number, y: number, container: PIXI.Container, diceSize: number, spaceBetweenDice: number, isMyDice: boolean = true, isLayoutHorizontal: boolean = true) {
        const dice2X = diceSize + spaceBetweenDice

        super(uiGameManager, x, y, diceSize * 2, diceSize, container, isMyDice)

        this.dice1 = new SpriteView(0, 0, diceSize, diceSize, this, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.dice_1))
        this.dice2 = new SpriteView(isLayoutHorizontal ? dice2X : 0, isLayoutHorizontal ? 0 : dice2X, diceSize, diceSize, this, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.dice_2))
        this.addDice(this.dice1)
        this.addDice(this.dice2)

        this.isRedDiceActive = isRedDiceActive
        this.updateDiceTexture()
    }

    updateDiceTexture() {
        if(this.uiGameManager.gameController.diceState.dice1 === undefined || this.uiGameManager.gameController.diceState.dice2 === undefined) return
        this.dice1.texture = UIGameSpriteHandler.getDiceImage(this.uiGameManager.gameController.diceState.dice1, this.isRedDiceActive)
        this.dice2.texture = UIGameSpriteHandler.getDiceImage(this.uiGameManager.gameController.diceState.dice2)
    }
}
